import { toast } from 'react-toastify';
import { replaceOrAddById } from '../App/Helpers/store';

export const messagesInitialState = {
	loading: false,
	items: [],
};

export const messagesReducer = (state = messagesInitialState, action) => {
	switch (action.type) {
		case 'MESSAGES_ADD':
		case 'MESSAGES_DELETE':
			return state;

		case 'MESSAGES_EDITING':
		case 'MESSAGES_LOADING':
			return {
				...state,
				loading: true,
			};

		case 'MESSAGES_GET':
			return {
				...state,
				loading: false,
				items: action.payload.data.data,
			};

		case 'MESSAGES_ERROR':
			toast.error('Virhe tietojen tallennuksessa');
			return {
				...state,
				loading: false,
			};
		case 'MESSAGES_EDITED':
			toast.success('Tiedot tallennettu');
			return {
				...state,
				loading: false,
			};

		case 'MESSAGE_SET_LOADING':
			let nitems = [...state.items];
			let nindex = nitems.findIndex((val) => {
				// eslint-disable-next-line eqeqeq
				return val.id == action.id;
			});
			if (nindex > -1) {
				nitems[nindex].loading = true;
			}

			return {
				...state,
				items: nitems,
				loading: false,
			};

		case 'MESSAGE_GET':
			const items = replaceOrAddById(
				[...state.items],
				action.payload.data.data
			);

			return {
				...state,
				items,
				loading: false,
			};

		default:
			return state;
	}
};
